// extracted by mini-css-extract-plugin
export default {"notFound":"NotFound_notFound__6-kto","empty":"NotFound_empty__-Bxrm","content":"NotFound_content__48SnK"};